import React from "react";
import "./offerTabFilters.scss";
import getTranslation from "../../TranslationUtility/TranslationUtility";
import filter from "../../Assets/imgNewUI/filter2.svg";
// Left-aligned, horizontally scrollable pill bar: a static "Filter"/"Filters"
// pill (icon when no filters are applied, a red count badge once filterCount > 0)
// followed by parent-supplied dynamic tabs. Same layout for mobile and web.
const OfferTabFilters = ({
  tabs = [],
  activeTabs = [],
  onTabClick,
  filterCount = 0,
  onFilterClick,
  filterIconUrl,
}) => {
  const translation = getTranslation();
  const hasActiveFilters = filterCount > 0;

  return (
    <div className="offer-tab-filters-wrapper">
      <div className="offer-tab-filters-bar">
        <button
          type="button"
          className={`offer-tab-pill offer-tab-filter-pill ${hasActiveFilters ? "has-active-filters" : ""}`}
          onClick={onFilterClick}
        >
          {hasActiveFilters ? (
            <span className="offer-tab-filter-count">{filterCount}</span>
          ) : (
            <img
              src={filterIconUrl}
              alt={"filter"}
              onError={(e) => { e.target.src = filter; }}
              className="offer-tab-filter-icon"
            />
          )}
          <span>{hasActiveFilters ? "Filters" : translation?.filter || "Filter"}</span>
        </button>

        {tabs?.map((tab) => {
          const tabKey = tab?.key ?? tab?.value;
          const isActive = activeTabs?.some((value) => String(value) === String(tabKey));
          return (
            <button
              key={tabKey}
              type="button"
              className={`offer-tab-pill ${isActive ? "active" : ""}`}
              onClick={() => onTabClick?.(tab)}
            >
              {tab?.label ?? tab?.value}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default OfferTabFilters;
